import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Grid, Panel, Row, Col, Form} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import ForgotPasswordForm from './ForgotPasswordForm';
import {FormErrors} from 'components/common';
import {forgotPassword} from 'api/account';
import {formatErrors} from 'actions/errors';
import {addFlashMessage} from 'actions/flash-message';
import {Typography} from '@material-ui/core';

class ForgotPassword extends React.Component {
  constructor() {
    super();
    this.state = {
      errors: {},
    };
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleFormSubmit(data) {
    const {formatErrors, addFlashMessage} = this.props;
    return forgotPassword(data)
      .then(() => addFlashMessage('Email sent. Please check you email.', 'success'))
      .catch((err) =>
        formatErrors(err).then((err) => {
          this.setState({
            errors: err,
          });
        }),
      );
  }

  render() {
    const {errors} = this.state;
    return (
      <div className="authentication forgot-password">
        <Grid className="content-box">
          <h1 className="kluwell-logo">
            <img alt="Kluwell" src="/images/kluwell-logo.svg" />
          </h1>
          <Panel>
            <FormErrors errors={errors} />
            <ForgotPasswordForm onSubmit={this.handleFormSubmit} />
            <Row>
              <br />
              <Typography style={{padding: '0 24px'}}>No email? Please ask you teacher for assistance</Typography>
              <br />
              <Col xs={12}>
                <Link to="/account/login">
                  <Button>Back to Login</Button>
                </Link>
              </Col>
            </Row>
          </Panel>
        </Grid>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  formatErrors: (...args) => dispatch(formatErrors(...args)),
  addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

export default connect(null, mapDispatchToProps)(ForgotPassword);
